import { render } from "./PivotSettings.vue?vue&type=template&id=ceb078ae&ts=true"
import script from "./PivotSettings.vue?vue&type=script&lang=ts"
export * from "./PivotSettings.vue?vue&type=script&lang=ts"

import "./PivotSettings.vue?vue&type=style&index=0&id=ceb078ae&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__